var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"communication"},[_c('leftMenu'),_vm._v(" "),(this.isLoading)?_c('dotLoader'):_vm._e(),_vm._v(" "),_c('page-header',{attrs:{"icon":"newspaper-outline","totalTabs":_vm.tabsAnnoucements,"headerProps":this.headerProps},on:{"tabSelectedChanged":_vm.myAction}}),_vm._v(" "),_c('annoucements-cards',{attrs:{"annoucements":_vm.annoucementsFiltered,"isLoading":this.isLoading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e18e116","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/views/restricted/communication/communication.vue
// module id = 1060
// module chunks = 0